import React, { useState } from "react";

const SustainabilitySection = () => {
  const [selectedButton, setSelectedButton] = useState(0);
  const images = [
    "https://media.istockphoto.com/id/1130906236/photo/three-roll-green-eco-garbage-bag-with-copy-space-isolated-on-grey-background.jpg?s=612x612&w=0&k=20&c=1gt8IAfMyjOA2uCGixP_KGNM0MYFP_pr0a3DmXmc3Yk=",
    "https://media.istockphoto.com/id/2155808440/photo/ldpe-recycled-plastic-bag.jpg?s=612x612&w=0&k=20&c=VIzqHizpCT9F9--M2mrg6N70Qt1Lg-buzmSF8VPAKEk=",
    "https://media.istockphoto.com/id/1458180972/photo/biodegradable-and-compostable-plastic-concept-renewable-raw-materials-used-plastic-is-under.jpg?s=612x612&w=0&k=20&c=pSY6Wmq7Wl3dOfSPf31Yxjj1zYMQn0mP8rbYxJ6x7s0=",
    "https://img.freepik.com/free-photo/top-view-plastic-carton-waste_23-2148666828.jpg?ga=GA1.1.1893459610.1724680332&semt=ais_hybrid",
  ];

  const buttons = [
    "Eco-Friendly",
    "Recyclable",
    "Biodegradable",
    "Sustainable",
  ];

  return (
    <section className="bg-background-primary py-16 flex min-h-screen items-center justify-center">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-around px-4 md:px-8 lg:px-12">
        {/* Right Half - Image */}
        <div className="w-full md:w-3/5 lg:w-1/2 flex items-center justify-center mb-8 md:order-last">
          <img
            src={images[selectedButton]}
            alt={`Selected ${buttons[selectedButton]}`}
            className="rounded-md w-full max-w-lg h-auto object-contain"
          />
        </div>

        {/* Left Half */}
        <div className="w-full md:w-1/2 flex flex-col items-start mb-8 md:mb-0">
          <h2 className="text-text-primary text-lg font-semibold mb-2">
            Sustainability
          </h2>
          <h2 className=" text-3xl font-bold mb-4 text-primary leading-tight">
            Green Packaging
          </h2>
          <p className="text-text-primary mb-6">
            We are committed to providing sustainable packaging solutions that
            help protect the environment. Choose from our eco-friendly options
            to meet your sustainability goals.
          </p>

          {/* Clickable Buttons */}
          <div className="flex flex-wrap justify-center max-w-[450px]">
            {buttons.map((title, index) => (
              <button
                key={index}
                onClick={() => setSelectedButton(index)}
                className={`shadow-md w-full sm:w-auto sm:min-w-[200px] min-h-[60px] m-2 text-sm font-medium border-grey200 rounded-md ${
                  selectedButton === index
                    ? "bg-secondary text-text-primary"
                    : "bg-background-primary text-background-secondary border-text-secondary"
                } hover:bg-secondary hover:text-text-primary transition-colors`}
              >
                {title}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SustainabilitySection;
